<div class="header mt-md-5">
  <div class="header-body">
    <div class="row align-items-center">
      <div class="col">

        <!-- Pretitle -->
        <h6 class="header-pretitle">
          Aperçu
        </h6>

        <!-- Title -->
        <h1 class="header-title">
          Mon Compte
        </h1>

      </div>
    </div> <!-- / .row -->
    <div class="row align-items-center">
      <div class="col">

        <!-- Nav -->
        <ul class="nav nav-tabs nav-overflow header-tabs">
          <li class="nav-item">
            <a [class.active]="this.menuService.menuItems['/account/general'].isActive" class="nav-link"
               routerLink="/account/general">
              Général
            </a>
          </li>
          <!--                    <li class="nav-item">-->
          <!--                        <a href="account-billing.html" class="nav-link">-->
          <!--                            Billing-->
          <!--                        </a>-->
          <!--                    </li>-->
          <!--                    <li class="nav-item">-->
          <!--                        <a href="account-members.html" class="nav-link">-->
          <!--                            Members-->
          <!--                        </a>-->
          <!--                    </li>-->
          <!--                    <li class="nav-item">-->
          <!--                        <a routerLink="/account/security" class="nav-link" [class.active]="this.menuService.menuItems['/account/security'].isActive">-->
          <!--                            Sécurité-->
          <!--                        </a>-->
          <!--                    </li>-->
          <!--                    <li class="nav-item">-->
          <!--                        <a routerLink="/account/notifications"  class="nav-link" [class.active]="this.menuService.menuItems['/account/notifications'].isActive">-->
          <!--                            Notifications-->
          <!--                        </a>-->
          <!--                    </li>-->
        </ul>

      </div>
    </div>
  </div>
</div>